const getTitleForPath = (path: string) => path?.replace(/:/g, '$');

export {getTitleForPath};
